import { routeForDocument } from '@metmuseum/routes';
import { routeForLibraryDocument } from './library-route';
export * from '@metmuseum/routes';

/*
	These sit at /departments/:departmentSlug/.../:slug, so a slug on its own cannot
	build their URL and routeForDocument has no way to express them. Callers supply the
	owning department as parentSlug.
*/
const DEPARTMENT_SCOPED_RESOURCE_TYPES = ['professionalResource'];

export const routeForDocumentWithSubsection = ({
	_type = '',
	slug = { current: '' },
	subsection = '',
	parentSlug = '',
}: {
	_type?: string;
	slug?: { current: string } | string;
	subsection?: string;
	parentSlug?: string;
}) => {
	const formattedSlug = typeof slug === 'string' ? slug : slug?.current;
	if (DEPARTMENT_SCOPED_RESOURCE_TYPES.includes(_type) && parentSlug) {
		const base = routeForLibraryDocument({
			_type,
			slug: formattedSlug,
			departmentSlug: parentSlug,
		});
		return `${base}${subsection || ''}`;
	}
	// For now, do the naive implementation. Correctness will be checked on the CMS side
	return `${routeForDocument({ _type, slug })}${subsection ? subsection : ''}`;
};

// This has changed again. Might as well use a constant for this route.
export const eventsCalendarRoute = '/events/calendar';

/*
	Attempting to keep track of all research-center sub pages.
	With the updated "person group" template - there is now the possibility of custom routes
	that pull for the Role Slug field. pass "AllowCustom" to override the default behavior
*/
export const researchCenterRoutes = (slug = '', page, allowCustom = false) => {
	const baseRoute = routeForDocument({
		_type: 'researchCenter',
		slug: { current: slug },
	});
	switch (page) {
		case 'team':
			return `${baseRoute}/team`;
		case 'advisory-committee':
			return `${baseRoute}/advisory-committee`;
		case 'distinguished-scholars':
			return `${baseRoute}/distinguished-scholars`;
		case 'fellowships':
			return `${baseRoute}/fellowships`;
		case 'fellows':
			return `${baseRoute}/fellows`;
		case 'publication-grants':
			return `${baseRoute}/publication-grants`;
		case `research-resources`:
			return `${baseRoute}/research-resources`;
		default:
			return allowCustom ? `${baseRoute}/${page}` : baseRoute;
	}
};
